import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from '../../shared/guards/auth.guards';
import { Groups } from '../security/model/groups.model';
import { UserListComponent } from './components/list/user-list.component';

export class UserRoutingStates {
  public static readonly LIST = {
    url: 'user'
  };
}

export const UserRoutes: Routes = [
  {
    path: UserRoutingStates.LIST.url,
    data: {
      page: {
        title: 'User List'
      },
      requiresRole: [
        Groups.USER_ADMIN,
        Groups.CLIENT_ADMIN,
        Groups.ENTERPRISE_SP_USER_MANAGER
      ]
    },
    component: UserListComponent,
    canActivate: [AuthGuard]
  }
];

@NgModule({
  exports: [RouterModule],
  imports: [RouterModule.forChild(UserRoutes)]
})
export class UserRoutingModule {}
